import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { Paginated, Role, UserRow } from "@/lib/types";

interface UsersQuery {
  search?: string;
  role?: Role | "";
  active?: "true" | "false" | "";
  page?: number;
  ordering?: string;
}

/** GET /api/v1/users/. Director+ only — RequireAuth on the page also
 * enforces this, plus the API itself returns 403. */
export function useUsers(q: UsersQuery = {}) {
  return useQuery<Paginated<UserRow>>({
    queryKey: ["users", q],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (q.search)   params.set("search",   q.search);
      if (q.role)     params.set("role",     q.role);
      if (q.active)   params.set("active",   q.active);
      if (q.page)     params.set("page",     String(q.page));
      if (q.ordering) params.set("ordering", q.ordering);
      const { data } = await api.get<Paginated<UserRow>>(
        `/users/?${params.toString()}`,
      );
      return data;
    },
  });
}
